/**
 * Zopup - Subcriptions API
 *
 * Contact: djoyrocks@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type SubscriptionStatus = 'Pending' | 'TrialPending' | 'TrialFuture' | 'TrialStarted' | 'TrailExpired' | 'TrailExtensionStarted' | 'TrailExtensionExpired' | 'TrialCancelled' | 'Future' | 'Active' | 'Inactive' | 'Paused' | 'Expired' | 'ScheduledForCancellation' | 'Cancelled';

export const SubscriptionStatus = {
    Pending: 'Pending' as SubscriptionStatus,
    TrialPending: 'TrialPending' as SubscriptionStatus,
    TrialFuture: 'TrialFuture' as SubscriptionStatus,
    TrialStarted: 'TrialStarted' as SubscriptionStatus,
    TrailExpired: 'TrailExpired' as SubscriptionStatus,
    TrailExtensionStarted: 'TrailExtensionStarted' as SubscriptionStatus,
    TrailExtensionExpired: 'TrailExtensionExpired' as SubscriptionStatus,
    TrialCancelled: 'TrialCancelled' as SubscriptionStatus,
    Future: 'Future' as SubscriptionStatus,
    Active: 'Active' as SubscriptionStatus,
    Inactive: 'Inactive' as SubscriptionStatus,
    Paused: 'Paused' as SubscriptionStatus,
    Expired: 'Expired' as SubscriptionStatus,
    ScheduledForCancellation: 'ScheduledForCancellation' as SubscriptionStatus,
    Cancelled: 'Cancelled' as SubscriptionStatus
};


